import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DesaparecidoFotografiaDto } from 'src/app/shared/models/gam/desaparecido-fotografia-dto.model';
import { DesaparecidoGamDto } from 'src/app/shared/models/gam/desaparecido-gam-dto.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DesaparecidoGamService {
  constructor(private http: HttpClient) { }

  findAll(): Observable<any> {
    return this.http.get(`${environment.apiSecurityUrl}api/v1/gam/desaparecidos`);
  }
  findById(id: number): Observable<any> {
    return this.http.get(`${environment.apiSecurityUrl}api/v1/gam/desaparecidos/${id}`);
  }

  persist(dto: DesaparecidoGamDto): Observable<any> {
    return this.http.post(`${environment.apiSecurityUrl}api/v1/gam/desaparecidos`, dto);
  }

  update(id: number, dto: DesaparecidoGamDto): Observable<any> {
    return this.http.put(`${environment.apiSecurityUrl}api/v1/gam/desaparecidos/${id}`, dto);
  }

  updateFotografia(id: number, obj: DesaparecidoFotografiaDto): Observable<any> {
    return this.http.put(`${environment.apiSecurityUrl}api/v1/gam/desaparecidos/${id}/photo`, obj);
  }
  delete(id: number): Observable<any> {
    return this.http.delete(`${environment.apiSecurityUrl}api/v1/gam/desaparecidos/${id}`);
  }
}
